export default "__VITE_ASSET__Brvd0nnR__"